/**
 * 日期时间展示工具（DB/接口统一 timestamptz(UTC)，UI 按设备本地时区显示）。
 */

/** ISO(UTC) -> 本地「YYYY-MM-DD HH:mm:ss」；解析失败原样返回。 */
export function fmtDateTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const p = (n: number): string => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

/** 到期日相对今天的本地日历日差（正数 = 已逾期天数；纯展示用途，是否逾期以服务端派生为准）。 */
export function calendarOverdueDays(dueAt: string): number {
  const startOfDay = (date: Date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  return Math.round((startOfDay(new Date()) - startOfDay(new Date(dueAt))) / 86400000);
}
